<template>
  <div class="app-container">
    <el-row>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="分组">
          <el-select
            v-model="page.param.groupLabel"
            filterable
            placeholder="选择分组"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in groupOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="page.param.name" placeholder="编码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-col style="text-align: left;margin-bottom: 5px;">
        <el-button @click="add()" icon="el-icon-edit-outline" type="primary"
          >添加</el-button
        >
      </el-col>
    </el-row>

    <el-table
      v-loading="page.loading"
      :data="page.data"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @sort-change="sortChange"
    >
      <el-table-column label="分组" prop="groupLabel" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.groupLabel }}
        </template>
      </el-table-column>
      <el-table-column label="分组名称" prop="groupTitle" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.groupTitle }}
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="dictLabel" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.dictLabel }}
        </template>
      </el-table-column>
      <el-table-column label="值" prop="dictValue" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.dictValue }}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="scope" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.score }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row.dictId)">编辑</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row.dictId)"
            ><i class="icon-delete"></i>删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="page.total > 0"
      :total="page.total"
      class="dict-pagination"
      :page.sync="page.param.currentPage"
      :limit.sync="page.param.pageSize"
      @pagination="fetchData"
    />

    <el-dialog
      :visible.sync="visible"
      title="添加"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="app-container">
        <el-form
          :model="Form"
          status-icon
          ref="ruleForm"
          label-position="right"
          size="small"
          label-width="150px"
          slot="dialog"
          :rules="rules"
        >
          <el-form-item prop="groupName" label="分组：">
            <el-input
              v-model="Form.groupLabel"
              style="width:400px"
              placeholder="分组"
            ></el-input>
          </el-form-item>

          <el-form-item prop="groupTitle" label="分组名称：">
            <el-input
              v-model="Form.groupTitle"
              style="width:400px"
              placeholder="分组名称"
            ></el-input>
          </el-form-item>

          <el-form-item prop="dictLabel" label="名称：">
            <el-input
              v-model="Form.dictLabel"
              style="width:400px"
              placeholder="名称"
            ></el-input>
          </el-form-item>

          <el-form-item prop="dictValue" label="值：">
            <el-input
              v-model="Form.dictValue"
              style="width:400px"
              placeholder="值"
            ></el-input>
          </el-form-item>

          <el-form-item prop="score" label="排序：">
            <el-input
              v-model="Form.score"
              style="width:400px"
              placeholder="排序"
            ></el-input>
          </el-form-item>

          <el-button @click="submit()">提交</el-button>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectDictList,writeDict,getDict,deleteDict,selectDictGroup } from '@/api'
import Pagination from '@/components/Pagination'

export default {
  components: { Pagination },
  data() {
    this.rules = {
      groupLabel: {
        type: 'string',
        required: true,
        trigger: 'blur',
        message: '分组必填!'
      },
      dictLabel: {
        type: 'string',
        required: true,
        trigger: 'blur',
        message: '编码必填!'
      },
      dictValue: {
        type: 'string',
        required: true,
        trigger: 'blur',
        message: '值必填!'
      }
    }
    return {
      page: {
        loading: true,
        data: null,
        total: 0,
        param: {
          currentPage: 1,
          pageSize: 10,
          sort: ''
        }
      },
      groupOption: [],
      visible: false,
      Form: {}
    }
  },
  created() {
    if (this.$route.query.pageIndex !== undefined) {
      this.page.param.currentPage = this.$route.query.pageIndex
    }
    if (this.$route.query.word !== undefined) {
      this.page.param.title = this.$route.query.word
    }
    this.fetchData()
    this.loadGroupSelect()
  },
  methods: {
    search() {
      this.page.param.currentPage = 1
      this.fetchData()
    },
    async fetchData() {
      this.page.loading = true

      // 网络请求
      let result = await selectDictList(this.page.param)
      console.log('这是返回的dictresult', result)

      this.page.data = result.list
      this.page.total = result.total
      this.page.loading = false
      console.log('this.page.total', this.page.total)
    },
    sortChange(data) {
      this.page.param.currentPage = 1
      this.page.param.sort = getSort(data)
      this.fetchData()
    },
    add() {
      this.Form = {}
      this.visible = true
    },
    del(val) {
      let that = this
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        deleteDict(val).then(res => {
          
          console.log("删除返回",res)
        })
        this.page.param.currentPage = 1
        that.fetchData()
      })
    },
    edit(dictId) {
      const data = {
        dictId: dictId
        }
      getDict(data).then(res => {
        this.Form = res
        this.visible = true
      })
      this.page.param.currentPage = 1
      this.fetchData()
    },
    submit() {
      let that = this
      this.$refs.ruleForm.validate(valid => { 
        if (valid) {
          let result =writeDict(this.Form)
          that.visible = false
        }
        this.page.param.currentPage = 1
        that.fetchData()
      })
    },
    loadGroupSelect() {
      this.page.loading = true
      selectDictGroup().then(res => {
        this.groupOption = res
        console.log("这是字典分组",res)
      })
    }
  }
}
</script>
<style lang="scss" scoped>


.dict-pagination {
  text-align: right;
}


</style>
